import React from "react";
import { Form, Row, Col, Button, FloatingLabel } from "react-bootstrap";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { findIcon } from "views/dashboard/icons";

const EventUserEngagementData = ({ channelData = [], forms, setForms }) => {
  const handleInputChange = (index, field, value) => {
    const formattedValue =
      field === "engagement_date" && value === "" ? "" : value;
    const newForms = [...forms];
    newForms[index][field] = formattedValue;
    setForms(newForms);
  };

  const addForm = () => {
    const lastForm = forms[forms.length - 1];
    const isFormComplete = Object.values(lastForm).every(
      (value) => value?.trim() !== ""
    );

    if (!isFormComplete) {
      toast.error("Please fill in all fields for user engagement.");
      return;
    }
    setForms([
      ...forms,
      {
        title: "",
        touchpoint_target: "",
        touchpoint_sent: "",
        delivered: "",
        seen: "",
        channel: "",
        engagement_date: "",
        template: "",
      },
    ]);
  };

  const removeForm = (index) => {
    const newForms = forms.filter((_, i) => i !== index);
    setForms(newForms);
  };

  return (
    <div>
      <p className="form-label">User Engagement</p>
      {forms?.map((form, index) => (
        <Form
          key={index}
          className="border border-1 border-primary border-opacity-25 border-dashed rounded-3 mb-4 p-4 px-3"
        >
          <Row>
            <Col xs="12">
              <FloatingLabel
                controlId={`textInput_${index}`}
                label={
                  <>
                    {"Title"} {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  type="text"
                  placeholder="Enter Title"
                  value={form.title}
                  onChange={(e) =>
                    handleInputChange(index, "title", e.target.value)
                  }
                />
              </FloatingLabel>
            </Col>

            <Col md="3" sm="6">
              <FloatingLabel
                controlId={`touchpointTarget_${index}`}
                label={
                  <>
                    {"Touchpoint Target"}{" "}
                    {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  type="number"
                  placeholder="Touchpoint Target"
                  value={form.touchpoint_target}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "touchpoint_target",
                      e.target.value
                    )
                  }
                />
              </FloatingLabel>
            </Col>
            <Col md="3" sm="6">
              <FloatingLabel
                controlId={`touchpointGiven_${index}`}
                label={
                  <>
                    {"Touchpoint Given"}{" "}
                    {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  type="number"
                  placeholder="Touchpoint Given"
                  value={form.touchpoint_sent}
                  onChange={(e) =>
                    handleInputChange(index, "touchpoint_sent", e.target.value)
                  }
                />
              </FloatingLabel>
            </Col>
            <Col md="3" sm="6">
              <FloatingLabel
                controlId={`delivered_${index}`}
                label={
                  <>
                    {"Delivered"} {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  type="number"
                  placeholder="Delivered"
                  value={form.delivered}
                  onChange={(e) =>
                    handleInputChange(index, "delivered", e.target.value)
                  }
                />
              </FloatingLabel>
            </Col>
            <Col md="3" sm="6">
              <FloatingLabel
                controlId={`seen_${index}`}
                label={
                  <>
                    {"Seen"} {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  type="number"
                  placeholder="Seen"
                  value={form.seen}
                  onChange={(e) =>
                    handleInputChange(index, "seen", e.target.value)
                  }
                />
              </FloatingLabel>
            </Col>
            <Col sm="6">
              <FloatingLabel
                controlId={`dropdown_${index}`}
                className="mb-3 custom-form-floating"
                label={
                  <>
                    {"Channel"} {<span className="text-danger">*</span>}
                  </>
                }
              >
                <Form.Select
                  value={form.channel}
                  onChange={(e) =>
                    handleInputChange(index, "channel", e.target.value)
                  }
                >
                  <option value="">Select a channel</option>
                  {channelData?.map((item) => (
                    <option value={item?.channel_id}>
                      {item?.channel_name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm="6">
              <FloatingLabel
                controlId={`dateInput_${index}`}
                label={
                  <>
                    {"Engagement Date"} {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  type="date"
                  value={dayjs(form.engagement_date).format("YYYY-MM-DD") || ""}
                  onChange={(e) =>
                    handleInputChange(index, "engagement_date", e.target.value)
                  }
                  onBlur={(e) =>
                    handleInputChange(index, "engagement_date", e.target.value)
                  }
                />
              </FloatingLabel>
            </Col>
            <Col xs="12">
              <FloatingLabel
                controlId={`textarea_${index}`}
                label={
                  <>
                    {"Template"} {<span className="text-danger">*</span>}
                  </>
                }
                className="mb-3 custom-form-floating"
              >
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Template"
                  value={form.template}
                  onChange={(e) =>
                    handleInputChange(index, "template", e.target.value)
                  }
                />
              </FloatingLabel>
            </Col>

            <Col
              lg={12}
              className="d-flex justify-content-center align-items-center gap-2 flex-wrap"
            >
              <Button
                variant="outline-danger"
                className="border-dashed flex-shrink-0 flex-sm-grow-0 flex-grow-1 px-md-4 px-3"
                onClick={() => removeForm(index)}
                disabled={index === 0 && forms.length < 2 ? true : false}
              >
                <span>{findIcon("Trash", "dual-tone", 22)}</span> Remove
              </Button>

              {forms.length - 1 === index && (
                <Button
                  variant="outline-primary"
                  className="border-dashed flex-shrink-0 flex-sm-grow-0 flex-grow-1 px-md-4 px-3"
                  onClick={addForm}
                >
                  <span>{findIcon("Plus", "solid", 22)}</span> Add Row
                </Button>
              )}
            </Col>
          </Row>
        </Form>
      ))}
    </div>
  );
};

export default EventUserEngagementData;
